import Terms from "pages/LandingPages/Terms";

export default function TermsPage() {
  return <Terms />;
}